import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { Row, Col } from "react-bootstrap"

import Images from "assets/images"
import { IDLE, PENDING } from "const"
import { MtDriveFile } from "server/models"
import { StateType } from "client/utils"
import { StoreType } from "client/store"
import {
    Logo,
    CKEditorAttachmentsEdit,
    Feedback,
    Button,
    SpinnerIcon,
} from "client/components"

import {
    Comment,
    CommentValidation,
    SaveCommentType,
} from "./index"
import {
    EditCommentWrapper,
    EditCommentDescriptionWrapper,
} from "./styled"

let isMounted: boolean

interface EditCommentProps {
    comment: Comment
    onSave: SaveCommentType
    onCancel: () => void
}

const EditComment = ({
    comment,
    onSave,
    onCancel,
}: EditCommentProps) => {
    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)

    const [description, setDescription] = useState("")
    const [renderDescription, setRenderDescription] = useState(false)
    const [attachments, setAttachments] = useState<readonly MtDriveFile[]>([])

    const [validation, setValidation] = useState<CommentValidation>(null)
    const [saveState, setSaveState] = useState<StateType>(IDLE)

    useEffect(() => {
        isMounted = true
        return () => {
            isMounted = false
        }
    }, [])

    useEffect(() => {
        const files: MtDriveFile[] = []
        comment.attachments.forEach((attachment) => {
            files.push(attachment.file)
        })
        setDescription(comment.comment)
        setRenderDescription(true)
        setAttachments(files)
        setValidation(null)
    }, [])

    const onSaveComment = () => {
        setSaveState(PENDING)

        const newCommentData: Comment = {
            id: comment.id,
            comment: description,
            author: comment.author || userData.userId,
        }

        onSave(
            newCommentData,
            attachments,
            (commentValidation) => {
                if (isMounted) {
                    setValidation(commentValidation)
                    setSaveState(IDLE)
                }
                if (commentValidation) return
                onCancel()
            },
        )
    }

    return (
        <EditCommentWrapper>
            {
                comment.id === null && ( // show user logo only for new comments
                    <Logo
                        style={{ position: "absolute", top: 0, left: 0 }}
                        size={40}
                        borderRadius={20}
                        logo={userData.userLogo || Images.noAvatar}
                    />
                )
            }
            <EditCommentDescriptionWrapper>
                {
                    renderDescription && (
                        <CKEditorAttachmentsEdit
                            description={description}
                            setDescription={setDescription}
                            attachments={attachments}
                            setAttachments={setAttachments}
                            showTitle={false}
                        />
                    )
                }
                <Feedback transform="translateY(-9px)">{validation && validation.comment}</Feedback>
                <Row>
                    <Col xs={12}>
                        <Button variant="success" row onClick={onSaveComment}>
                            {saveState === PENDING ? <SpinnerIcon /> : lang.send}
                        </Button>
                        <Button row onClick={onCancel}>{lang.cancel}</Button>
                    </Col>
                </Row>
            </EditCommentDescriptionWrapper>
        </EditCommentWrapper>
    )
}
export default EditComment
